// adapted from https://stackoverflow.com/a/34064434/393274
function htmlToText(html) {
	if (!html) {
		return ''
	}
	var doc = new DOMParser().parseFromString(html, 'text/html')
	return doc.documentElement.textContent || ''
}

export default htmlToText

htmlToText.__filename__ = 'components/html-to-text.js'
